import React from 'react';
import EventCategoryLayout from '../../components/EventCategoryLayout';

const ConcertEvents = () => {
  return <EventCategoryLayout categoryId="concert" />;
};

export default ConcertEvents;
